import { APP_URL_MEDICAL, MEDICALEXAM, TYPEEXAM } from '../constants';
import HttpClient from '../services/HttpClient';

export const getMedicalExam = (filters, paginador) => {
    const headers = {"Content-Type": "application/json"}
    return new Promise((resolve) => {
        HttpClient.post(`${APP_URL_MEDICAL}${MEDICALEXAM}criteria/?page=${paginador?.page}&size=${paginador?.size}&order=${paginador?.order}&columnOrder=${paginador?.columnOrder}`, filters, headers).then((response) =>{
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

export const createMedicalExam = (body) => {
    const headers = {"Content-Type": "application/json"}
    return new Promise((resolve) => {
        HttpClient.post(`${APP_URL_MEDICAL}${MEDICALEXAM}`, body, headers).then((response) =>{
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

export const getExamType = () => {
    return new Promise((resolve) => {
        HttpClient.get(`${APP_URL_MEDICAL}${TYPEEXAM}ACTIVO`).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

export const dowloadOrderExam = (examId) => {
    const headers = {"Content-Type": "application/json"}
    return new Promise((resolve) => {
        HttpClient.get(`${APP_URL_MEDICAL}${MEDICALEXAM}${examId}/documents`, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error.response);
        })
    })
}

export const dowloadOrderExamNext = (examId, saeDocumentId ) => {
    const headers = {"Content-Type": "application/json"}
    return new Promise((resolve) => {
        HttpClient.get(`${APP_URL_MEDICAL}${MEDICALEXAM}${examId}/download-report/${saeDocumentId}`, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error.response);
        })
    })
}

export const uploadReport = (reports, examId) => {
    const headers = {"Content-Type": "application/json"}
    return new Promise((resolve) => {
        HttpClient.post(`${APP_URL_MEDICAL}${MEDICALEXAM}${examId}/upload-report`,reports, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error.response);
        })
    })
}